module.exports = __webpack_public_path__ + "img/pond-cj.23265092.png";